import { Button } from '@mui/material';
import { useTheme } from '@mui/styles';
import { Failure, Success } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { ApprovalButtonProps } from './types';

const getButtonText = (buttonType: string) => {
    switch (buttonType) {
        case 'approve':
            return 'Approve';
        case 'approved':
            return 'Approved';
        case 'decline':
            return 'Decline';
        case 'declined':
            return 'Declined';
        case 'cancel':
            return 'Cancel';
        case 'canceled':
            return 'Canceled';
        default:
            return buttonType;
    }
};

const getButtonIcon = (buttonType: string, theme: typeof muiTheme) => {
    switch (buttonType) {
        case 'approve':
        case 'approved':
            return (
                <Success
                    iconColor={theme?.app?.applicationColors.successDark || '#56B4BC'}
                />
            );
        case 'decline':
        case 'declined':
            return (
                <Failure
                    iconColor={theme?.app?.applicationColors.failureDark || '#CE4A4A'}
                />
            );
        default:
            return null;
    }
};

export default function ApprovalButton(props: ApprovalButtonProps) {
    const {
        id,
        type,
        disabled,
        onClick
    } = props;
    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    const getButtonClass = () => {
        switch (type) {
            case 'approved':
                return classes.approvedButton;
            case 'approve':
                return classes.approveButton;
            case 'decline':
                return classes.declineButton;
            case 'declined':
                return classes.declinedButton;
            case 'cancel':
                return classes.cancelButton;
            case 'canceled':
                return classes.canceledButton;
            default:
                return '';
        }
    };

    return (
        <Button
            classes={{
                text: classes.buttonLabel,
                startIcon: classes.buttonIcon
            }}
            className={`${classes.button} ${getButtonClass()}`}
            disabled={disabled}
            disableRipple={type === 'approved' || type === 'declined' || type === 'canceled'}
            id={id}
            onClick={onClick}
            startIcon={getButtonIcon(type, theme)}
        >
            {getButtonText(type)}
        </Button>
    );
}